import { useEffect, useState } from "react";
import "./ExcluirMotivoDefeitoModal.css";

export default function ExcluirMotivoDefeitoModal({ open, titulo, onClose, onConfirmar }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  async function handleOk() {
    if (busy) return;
    setBusy(true);
    setErr("");
    try {
      await onConfirmar?.();
      onClose?.();
    } catch (e) {
      setErr(e?.response?.data?.error || e?.message || "Falha ao excluir.");
    } finally {
      setBusy(false);
    }
  }

  useEffect(() => {
    if (!open) return;
    setBusy(false);
    setErr("");
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="ptex-bg" onClick={onClose}>
      <div className="ptex-box" role="dialog" aria-modal="true" aria-label="Excluir motivo" onClick={(e) => e.stopPropagation()}>
        <header className="ptex-head">
          <h3 className="ptex-title">Excluir</h3>
          <button className="ptex-x" onClick={onClose} type="button" aria-label="Fechar" disabled={busy}>
            x
          </button>
        </header>

        <div className="ptex-body">
          Tem certeza que deseja <strong>excluir</strong> "{titulo || "este motivo"}"?
          <div className="ptex-warn">Esta acao nao pode ser desfeita.</div>
          {err ? <div className="ptex-err">{err}</div> : null}
        </div>

        <footer className="ptex-foot">
          <button className="ptex-btn" type="button" onClick={onClose} disabled={busy}>Cancelar</button>
          <button className="ptex-btn ptex-btn-danger" type="button" onClick={handleOk} disabled={busy}>
            {busy ? "Excluindo..." : "Excluir"}
          </button>
        </footer>
      </div>
    </div>
  );
}

